module.exports = __webpack_public_path__ + "media/bl_mobile_scrolling.0ea3677c.mp4";